module.exports = __webpack_public_path__ + "img/FB-cover-photo-03.f69ffda7.jpg";